import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

var throttle = function throttle(callback, wait) {
  var next = function next() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout = clearTimeout(timeout);
    callback.apply(void 0, _toConsumableArray(lastArgs));
  };

  var timeout;
  var lastArgs;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args; // eslint-disable-next-line no-void

    if (timeout === void 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      timeout = setTimeout(next, wait);
    }
  };
};

export { throttle };